export const timingList = [
  // タイミングA
  [
    {
      label: 'アラームを解除する',
      answer: 'アラームを解除したら'
    },
    {
      label: 'カーテンを開ける',
      answer: 'カーテンを開けたら'
    },
    {
      label: 'カーテンを閉じたら',
      answer: 'カーテンを閉じたら'
    },
    {
      label: '窓を開ける',
      answer: '窓を開けたら'
    },
    {
      label: '窓を閉める',
      answer: '窓を閉めたら'
    },
    {
      label: 'エアコンをつける',
      answer: 'エアコンをつけたら'
    },
    {
      label: 'ベッドから出る',
      answer: 'ベッドから出たら'
    },
    {
      label: 'ベッドに入る',
      answer: 'ベッドに入ったら'
    },
    {
      label: '布団を畳む',
      answer: '布団を畳んだら'
    },
    {
      label: '布団を出す',
      answer: '布団を出したら'
    },
    {
      label: '布団に入る',
      answer: '布団に入ったら'
    },
    {
      label: '照明をつける',
      answer: '照明をつけたら'
    },
    {
      label: '照明を消す',
      answer: '照明を消したら'
    },
    {
      label: '椅子に座る',
      answer: '椅子に座ったら'
    },
    {
      label: 'ソファに座る',
      answer: 'ソファに座ったら'
    },
  ],
  // タイミングB
  [
    {
      label: 'お手洗いに行く',
      answer: 'お手洗いに行ったら'
    },
    {
      label: '手を洗う',
      answer: '手を洗ったら'
    },
    {
      label: 'うがいをする',
      answer: 'うがいをしたら'
    },
    {
      label: '顔を洗う',
      answer: '顔を洗ったら'
    },
    {
      label: '歯を磨く',
      answer: '歯を磨いたら'
    },
    {
      label: 'お化粧をする',
      answer: 'お化粧をしながら/したら'
    },
    {
      label: '髭を剃る',
      answer: '髭を剃ったら'
    },
    {
      label: 'シャワーを浴びる',
      answer: 'シャワーを浴びたら'
    },
    {
      label: '湯船に浸かる',
      answer: '湯船に浸かったら'
    },
    {
      label: '髪を乾かす',
      answer: '髪を乾かしたら'
    },
    {
      label: 'パックをする',
      answer: 'パックをしながら/したら'
    },
  ],
  // タイミングC
  [
    {
      label: '着替える',
      answer: '着替えたら'
    },
    {
      label: '寝巻きに着替える',
      answer: '寝巻きに着替えたら'
    },
    {
      label: 'スリッパを履く',
      answer: 'スリッパを履いたら'
    },
    {
      label: 'ベルトを締める',
      answer: 'ベルトを締めたら'
    },
    {
      label: 'コート/ジャケットを羽織る',
      answer: 'コート/ジャケットを羽織ったら'
    },
    {
      label: 'コート/ジャケットを脱ぐ',
      answer: 'コート/ジャケットを脱いだら'
    },
    {
      label: '靴を履く',
      answer: '靴を履いたら'
    },
  ],
  // タイミングD
  [
    {
      label: 'PCを起動する',
      answer: 'PCを起動したら'
    },
    {
      label: 'PCをシャットダウンする',
      answer: 'PCをシャットダウンしたら'
    },
    {
      label: 'タイムカードを切る',
      answer: 'タイムカードを切ったら'
    },
    {
      label: 'メールをチェックする',
      answer: 'メールをチェックしたら'
    },
    {
      label: 'LINEをチェックする',
      answer: 'LINEをチェックしたら'
    },
  ],
  // タイミングE
  [
    {
      label: '冷蔵庫を開ける',
      answer: '冷蔵庫を開けたら'
    },
    {
      label: '調理する',
      answer: '調理しながら/したら'
    },
    {
      label: '食事を注文する',
      answer: '食事を注文したら'
    },
    {
      label: '朝食をとる',
      answer: '朝食をとったら'
    },
    {
      label: '昼食をとる',
      answer: '昼食をとったら'
    },
    {
      label: '夕食をとる',
      answer: '夕食をとったら'
    },
    {
      label: 'コーヒー/お茶を飲む',
      answer: 'コーヒー/お茶を飲んだら'
    },
    {
      label: '食器を洗う',
      answer: '食器を洗ったら'
    },
    {
      label: '掃除をする',
      answer: '掃除をしたら'
    },
    {
      label: '洗濯機を回す',
      answer: '洗濯機を回したら'
    },
    {
      label: '洗濯物を干す',
      answer: '洗濯物を干したら'
    },
    {
      label: '洗濯物を畳む',
      answer: '洗濯物を畳んだら'
    },
  ],
  // タイミングF
  [
    {
      label: '歩く',
      answer: '歩きながら'
    },
    {
      label: '走る',
      answer: '走りながら'
    },
    {
      label: '電車/バスを待つ',
      answer: '電車/バスを待ちながら'
    },
    {
      label: '電車/バスに乗る',
      answer: '電車/バスに乗ったら'
    },
    {
      label: 'タクシーに乗る',
      answer: 'タクシーに乗ったら'
    },
    {
      label: '車を運転する',
      answer: '車を運転しながら'
    },
    {
      label: '人を送る',
      answer: '人を送りながら/送ったら'
    },
    {
      label: '人を迎えに行く',
      answer: '人を迎えに行きながら/行ったら'
    },
  ],
  // タイミングG
  [
    {
      label: '音楽を流す',
      answer: '音楽を流しながら'
    },
    {
      label: 'イヤホンをつける',
      answer: 'イヤホンをつけたら'
    },
    {
      label: '動画を見る',
      answer: '動画を見ながら/見たら'
    },
    {
      label: 'TVをつける',
      answer: 'TVをつけたら'
    },
    {
      label: 'ゲームで遊ぶ',
      answer: 'ゲームで遊びながら/遊んだら'
    },
    {
      label: 'タバコを吸う',
      answer: 'タバコを吸いながら/吸ったら'
    },
    {
      label: 'お酒を飲む',
      answer: 'お酒を飲んだら'
    },
    {
      label: 'フィットネスバイクを漕ぐ',
      answer: 'フィットネスバイクを漕ぎながら'
    },
    {
      label: 'トレッドミルで走る',
      answer: 'トレッドミルで走りながら'
    },
    {
      label: 'ウェイトトレーニングをする',
      answer: 'ウェイトトレーニングをしながら'
    },
    {
      label: 'ストレッチをする',
      answer: 'ストレッチをしながら'
    },
    {
      label: 'ヨガ/ピラティスをする',
      answer: 'ヨガ/ピラティスをしながら'
    },
    {
      label: '瞑想する',
      answer: '瞑想したら'
    },
    {
      label: '本を読む',
      answer: '本を読んだら'
    },
    {
      label: '新聞を読む',
      answer: '新聞を読んだら'
    },
    {
      label: 'SNSをチェックする',
      answer: 'SNSをチェックしたら'
    },
    {
      label: 'SNSに投稿する',
      answer: 'SNSに投稿したら'
    },
  ],
  // タイミングH
  [
    {
      label: 'Shadowingをする',
      answer: 'Shadowingをしたら'
    },
    {
      label: '単語を1セット覚える',
      answer: '単語を1セット覚えたら'
    },
    {
      label: '文法問題集を解く',
      answer: '文法問題集を解いたら'
    },
    {
      label: '音読をする',
      answer: '音読をしたら'
    },
    {
      label: 'Pattern Practice をする',
      answer: 'Pattern Practice をしたら'
    },
    {
      label: 'Overlapping をする',
      answer: 'Overlapping をしたら'
    },
  ]
]